var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_4451",
    "data-name": "Groupe 4451",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.34,
    height: 41.374,
    viewBox: "0 0 45.34 41.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_758",
    "data-name": "Trac\\xE9 758",
    d: "M180.764,183.625l-4.851-3.42a1.33,1.33,0,0,0-2.094,1.086v2.092H150.524a1.328,1.328,0,1,0,0,2.657h23.294v2.092a1.33,1.33,0,0,0,2.094,1.086l4.851-3.42a1.331,1.331,0,0,0,0-2.172",
    transform: "translate(-135.985 -164.024)",
    fill: "#202b53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_759",
    "data-name": "Trac\\xE9 759",
    d: "M38.121,29.217a1.329,1.329,0,0,0-1.815.485,18.03,18.03,0,1,1,0-18.029,1.328,1.328,0,0,0,2.3-1.33,20.687,20.687,0,1,0,0,20.689,1.329,1.329,0,0,0-.485-1.815",
    transform: "translate(0)",
    fill: "#202b53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.49e7122a721fc7d92b93f509a8b5ccbe.svg";
export { ForwardRef as ReactComponent };